import store from "@frameworks/web/redux/store";
import { ADBLOCK, ADBLOCK_HIDE_ERROR, ADBLOCK_SET_ERROR, ADBLOCK_START_LOADER, ADBLOCK_STOP_LOADER, } from "../../interfaces/Home/iAdBlock";
class AdBlockActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getAdBlock(data) {
        this.dispatch({
            type: ADBLOCK,
            payload: { data },
        });
    }
    startLoader() {
        this.dispatch({
            type: ADBLOCK_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: ADBLOCK_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: ADBLOCK_SET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: ADBLOCK_HIDE_ERROR,
        });
    }
}
export default AdBlockActions;
